import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withTheme, Paper} from "@material-ui/core";

const Component = styled(({props, ...others}) => (
    <Paper square {...others} />
))`
    margin: ${props => props.theme.spacing(1)}px;
    padding: ${props => props.theme.spacing(2)}px;
    position: relative;
`;

const PaperContainer = ({theme, children}) => {
    return (
        <Component
            theme={theme}
        >
            {children}
        </Component>
    );
};

PaperContainer.propTypes = {
    theme: PropTypes.object,
    children: PropTypes.node
};

export default withTheme(PaperContainer);
